/**
* Navigation Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Navigation Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'navigation-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function dupeSlider( sliderContainer, slider, slide, rtl = false ) {
        const originalSlideClass = 'is-original-slide';
        const textClass = 'navigation-banner__text';

        $( `.${sliderContainer}` ).each( function() {
          const section = $( this );
          const $slider = section.find( `.${slider}` );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;

          // Reset to the original slides (markup now includes >= 7 real/repeated
          // slides server-side, see navigation-banner.php) so that re-running this
          // on window resize doesn't keep cloning clones on top of clones.
          let $originals = $slider.find( `.${slide}.${originalSlideClass}` );

          if ( $originals.length === 0 ) {
            $originals = $slider.find( `.${slide}` ).addClass( originalSlideClass );
          } else {
            $slider.find( `.${slide}` ).not( `.${originalSlideClass}` ).remove();
          }
          if ( $originals.length === 0 ) {
            return;
          }

          let totalWidth = 0;
          $originals.each( function() {
            totalWidth += $( this ).find( `.${textClass}` ).width();
          } );

          if ( totalWidth === 0 ) {
            return;
          }
          let iterations = 0;
          const maxIterations = 20; // safety net only; doubling below converges well before this
          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            // Clone every slide currently in the track (originals + clones added
            // this pass), so width roughly doubles each iteration instead of
            // growing by a fixed original-only increment.
            $slider.find( `.${slide}` ).each( function() {
              const $clone = $( this ).clone().removeClass( originalSlideClass );
              $slider.append( $clone );
              totalWidth += $clone.find( `.${textClass}` ).width();
            } );
            iterations++;
          }

          if ( rtl ) {
            $slider.not( '.slick-initialized' ).slick( {
              speed: 8500,
              autoplay: true,
              autoplaySpeed: 0,
              cssEase: 'linear',
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              infinite: true,
              arrows: false,
              buttons: false,
              dots: false,
              variableWidth: true,
              rtl: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          } else {
            $slider.not( '.slick-initialized' ).slick( {
              dots: false,
              arrows: false,
              variableWidth: true,
              autoplay: true, // Enable autoplay
              autoplaySpeed: 0, // Set autoplay speed (in milliseconds)
              infinite: true, // Enable infinite looping
              slidesToShow: 3, // Number of slides to show at a time
              slidesToScroll: 1, // Number of slides to scroll at a time
              speed: 8500, // Transition speed (in milliseconds)
              cssEase: 'linear', // Easing function for transitions
              pauseOnHover: false, // Do not pause on hover
              pauseOnFocus: false, // Do not pause on focus
              centerMode: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          }
        } );
      }
      $( function() {
        if ( sessionStorage.getItem( 'navigation-banner' ) ) {
          document.documentElement.style.setProperty( '--siteBannerHeight', '0px' );
        }
        const banner = document.querySelector( '.navigation-banner' );
        if ( !sessionStorage.getItem( 'navigation-banner' ) ) {
          banner.classList.remove( 'll-banner-hidden' );
          $( '.ll-close' ).on( 'click', function( e ) {
            e.preventDefault();
            document.documentElement.style.setProperty( '--siteBannerHeight', '0px' );
            $( '.navigation-banner' ).css( 'display', 'none' );
            sessionStorage.setItem( 'navigation-banner', true );
          } );
        }
        const navslider = new app.components.common.Throttle( dupeSlider( 'navigation-banner', 'navigation-slider', 'slide', false ), 250 );
        $( window ).on( 'resize', function() {
          navslider.run();
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'navigation-banner', COMPONENT );
} )( app );
